import clsx from "clsx";
/**
 * className composer. All components accept className?: string and merge it
 * via cn() so callers can override or extend without losing component defaults.
 */
export function cn(...inputs) {
    return clsx(inputs);
}
